import script from "./register.vue?vue&type=script&setup=true&name=Register&lang=js"
export * from "./register.vue?vue&type=script&setup=true&name=Register&lang=js"

import "./register.vue?vue&type=style&index=0&id=b693ef98&scoped=true&lang=css"
import "./register.vue?vue&type=style&index=1&id=b693ef98&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b693ef98"]])

export default __exports__